/**
 * _autosize.js — grow a chat composer textarea to fit its text.
 *
 * Used by the Chip AI and Support composers (textarea.pchat-input). The CSS
 * owns the limits: min-height keeps one line, max-height caps the growth and
 * the box scrolls beyond it (public_chat.css, textarea.pchat-input).
 */

// The box is border-box sized and scrollHeight leaves out the border, so the
// border is added back or every line is clipped by it. A hidden box measures
// 0; the CSS min-height then keeps it one line tall.
export function autosizeTextarea(textarea) {
    textarea.style.height = 'auto';
    const border = textarea.offsetHeight - textarea.clientHeight;
    textarea.style.height = `${textarea.scrollHeight + border}px`;
}
